import Path from "../../../services/paths";
import ApprovalAction from '../../prat_actions/promotion/approvalAction'
import utils from "../../common/utils";
import CustomToast from '../../../util-functions/customToast.jsx'
import {getCookie} from '../../../util-functions/util-funtions'

class ApprovalsMiddleware {

  static approvalsList() {
    return dispatch => {
      dispatch(ApprovalAction.approvalList_Request());
      utils.get_token()
        .then(token => {
          fetch(Path.GET_ACTIVITIES_LIST, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => res.json())
            .then(res => {
              dispatch(ApprovalAction.approvalList_Success(res));

            })
            .catch(error => {
              dispatch(ApprovalAction.approvalList_Failed(error));
            });
        })
        .catch(error => {
          dispatch(ApprovalAction.approvalList_Failed(error));
        });
    };
  }

  static get_activity(guid) {
    return dispatch => {
      dispatch(ApprovalAction.specificActivity_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${guid}/activity_submitted/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => res.json())
            .then(res => {
              dispatch(ApprovalAction.specificActivity_Success(res));

            })
            .catch(error => {
              dispatch(ApprovalAction.specificActivity_Failed(error));
            });
        })
        .catch(error => {
          dispatch(ApprovalAction.specificActivity_Failed(error));
        });
    };
  }

  static post_submitApproval(__id, data, flag) {
    const csrftoken = getCookie('csrftoken');
    return dispatch => {
      dispatch(ApprovalAction.submitApproval_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${__id}/activity_submit/`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            body: JSON.stringify(data === '' ? null : flag === true ? { 'Promotion': data } : { 'ANP': data })

          })
            .then(res => res.json())
            .then(data => {
              if (!data.guid) {
                dispatch(ApprovalAction.submitApproval_Failed(data))
              }
              dispatch(ApprovalAction.submitApproval_Success(data))
            })
            .catch(err => {
              dispatch(ApprovalAction.submitApproval_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(ApprovalAction.submitApproval_Failed(err.message))

        })
    }
  };

  //---------MTFTS SUBMIT ACTIVITY API

  static post_mtfts_submitApproval(__id, data, flag) {
    const csrftoken = getCookie('csrftoken');
    return dispatch => {
      dispatch(ApprovalAction.mtfts_submitApproval_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/mtfts/${__id}/activity_submit/`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            body: JSON.stringify(data === '' ? null : flag === true ? { 'Promotion': data } : { 'ANP': data })

          })
            .then(res => res.json())
            .then(data => {
              if (!data.guid) {
                dispatch(ApprovalAction.mtfts_submitApproval_Failed(data))
              }
              dispatch(ApprovalAction.mtfts_submitApproval_Success(data))
            })
            .catch(err => {
              dispatch(ApprovalAction.mtfts_submitApproval_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(ApprovalAction.mtfts_submitApproval_Failed(err.message))

        })
    }
  };
  //---------MTFTS SUBMIT ACTIVITY API


  static getApprovalHistory(__id) {
    return dispatch => {
      dispatch(ApprovalAction.Approval_History_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${__id}/approval_history/`, {
            method: 'GET',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            }

          })
            .then(res => res.json())
            .then(data => {
              // if(!data.guid){
              // dispatch(ApprovalAction.Approval_History_Failed(data))
              // }
              dispatch(ApprovalAction.Approval_History_Success(data))
            })
            .catch(err => {
              dispatch(ApprovalAction.Approval_History_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(ApprovalAction.Approval_History_Failed(err.message))

        })
    }
  }

  static postApprovalSubmit(__id, data, history) {
    return dispatch => {
      dispatch(ApprovalAction.Approval_Submit_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${__id}/activity_workflow/`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data, __id)

          })
            .then(res => res.json())
            .then(data => {
              if (data.non_field_errors) {
                dispatch(ApprovalAction.Approval_Submit_Failed(data))
              } else {
                dispatch(ApprovalAction.Approval_Submit_Success(data))
                // ToastsStore.success(data.status + ' successful')
                CustomToast('success', data.status + ' successful' )
                history.push('/promotionlist')
              }
            })
            .catch(err => {
              dispatch(ApprovalAction.Approval_Submit_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(ApprovalAction.Approval_Submit_Failed(err.message))

        })
    }
  }

  static getSendBackHistory(__id) {
    return dispatch => {
      dispatch(ApprovalAction.Sendback_History_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${__id}/sendback_approval_history/`, {
            method: 'GET',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            }

          })
            .then(res => res.json())
            .then(data => {
              // if(!data.guid){
              // dispatch(ApprovalAction.Approval_History_Failed(data))
              // }
              dispatch(ApprovalAction.Sendback_History_Success(data))
            })
            .catch(err => {
              dispatch(ApprovalAction.Sendback_History_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(ApprovalAction.Sendback_History_Failed(err.message))

        })
    }
  }

  static getOldPreopso(_guid) {
    return dispatch => {
      dispatch(ApprovalAction.old_preopso_data_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${_guid}/old_preopso_codes/`, {
            method: 'GET',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            }

          })
            .then(res => res.json())
            .then(data => {
              // if(!data.guid){
              dispatch(ApprovalAction.old_preopso_data_Success(data))
              // }
              // dispatch(ApprovalAction.Sendback_History_Success(data))
            })
            .catch(err => {
              dispatch(ApprovalAction.old_preopso_data_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(ApprovalAction.old_preopso_data_Failed(err.message))

        })
    }
  }
  
}



export default ApprovalsMiddleware;
